<main class="outer-container form-outer-container">
  <section class="inner-form-container">
    <form [formGroup]="emailForm">
      <mat-form-field class="quick-apply-form-field" aria-label="Email entry form">
        <mat-label>{{ (talentHappyPathDataService.isGeneralApplication ? "talent-happy-path.quick-apply.email-login-page.email-general-application" : "talent-happy-path.quick-apply.email-login-page.email") | translate }}</mat-label>
        <input matInput
               id="email-input"
               formControlName="email"
               aria-label="Enter an email address here." [maxLength]="80">
        <mat-error class="quick-apply-hint" *ngIf="emailForm.get('email').invalid && (emailForm.get('email').dirty || emailForm.get('email').touched)">
          {{"talent-happy-path.quick-apply.email-login-page.email-username-invalid" | translate}}
        </mat-error>
      </mat-form-field>
    </form>
    <app-location-picker *ngIf="talentHappyPathDataService.isGeneralApplication" [formGroup]="emailForm" [talent]="talent"></app-location-picker>
  </section>

  <section class="button-container">
    <button mat-flat-button
            id="email-submit-button"
            color="primary"
            [disabled]="emailForm.invalid"
            (click)="submit(emailForm)"
            class="continue-button single-custom-button">
      <mat-icon>arrow_forward</mat-icon>
      {{"talent-happy-path.quick-apply.continue" | translate}}
    </button>
  </section>
</main>
